export default __webpack_public_path__ + "static/media/vector.6aedff7a.svg";